import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useHoverable } from "@gemini/core";
import { ExternalLinkIcon } from "@gemini/icons";
import { IS_SERVER } from "@/constants";
export const LocationLink = (prop) => {
    const { boxProps, isHovered } = useHoverable();
    const openExternalWindow = () => {
        if (IS_SERVER)
            return;
        window === null || window === void 0 ? void 0 : window.open(prop.link, "_blank");
    };
    return (_jsxs(Box, { ...boxProps, as: "button", typography: "typography.body.16.regularUnderlined", textAlign: "left", color: isHovered
            ? "color.content.interactive.hover"
            : "color.content.interactive.default", cursor: "pointer", borderStyle: "hidden", outlineStyle: "hidden", padding: 0, marginRight: "spacing.8", onClick: () => openExternalWindow(), children: [prop.title, _jsx(ExternalLinkIcon, { size: "sizing.16", marginLeft: "spacing.4" })] }));
};
